module.exports = __webpack_public_path__ + "static/media/insigniaGooglePlay.4263a06f.png";